import * as yup from 'yup'
import { ApplicationFormAnswers } from '../components/ApplicationForm/ApplicationFormContext'
import TitleOptions from '../components/Questions/TitleQuestion/TitleOptions'
import BaseValidator from './BaseValidator'

const TitleValidator = (): BaseValidator => {
  const schema = yup.object().shape({
    title: yup.string()
      .oneOf(TitleOptions.map((o) => o.value))
      .required()
  })

  return {
    getValidator: () => schema,
    validateState: (state: ApplicationFormAnswers) => schema.isValidSync({
      title: state.personalDetails?.title?.toLowerCase()
    })
  }
}

export default TitleValidator
